import { render } from "./HeroiconsSolidMinusCircle.vue?vue&type=template&id=bae6c64e"
const script = {}

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidMinusCircle.vue"]])

export default __exports__